import type { Promotion } from '../types'

export function getPromotionVariables(
  promotion: Promotion | null | undefined,
  providerDisplayName: string,
) {
  if (!promotion) {
    return undefined
  }
  return {
    provider: providerDisplayName,
    coupon: promotion.coupon,
    transferCredit: promotion.transferCredit
      ? `${promotion.transferCredit.amount} ${promotion.transferCredit.currency}`
      : null,
  }
}
